import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import CodePanel from '@/components/Landing/CodePanel';
import { CtaRow, GhostCta, PrimaryCta, Section, useLanding } from '@/components/Landing/LandingKit';
import { fluid, MONO } from '@/components/Landing/landingTokens';
import { BASE_URL, MODEL_TOTAL, PROVIDER_TOTAL, QUICKSTART } from '@/constants/apiContent';
import { ApiBody, ApiSplit } from './ApiEditorial';

function ApiHero({ topInset = 0 }) {
  const { c, width, isXS, isCompact } = useLanding();
  const size = fluid(width, 40, 62);
  return (
    <Section label="Gab AI API" contentStyle={{ paddingTop: (isXS ? topInset : 0) + fluid(width, 108, 144), paddingBottom: fluid(width, 44, 72) }}>
      <ApiSplit style={{ alignItems: isCompact ? 'stretch' : 'center' }}>
        <View style={{ flex: isCompact ? undefined : 1, minWidth: 0 }}>
          <Text weight="medium" style={{ color: c.accent, fontSize: 14, marginBottom: 24 }}>Gab AI for developers</Text>
          <Text tag="h1" weight="semibold" style={{ color: c.ink, fontSize: size, lineHeight: Math.round(size * 1.06), letterSpacing: -size * 0.045 }}>{MODEL_TOTAL} models. One API.</Text>
          <ApiBody style={{ fontSize: 18, lineHeight: 29, marginTop: 24 }}>Build chat, image, video, and audio into your app with models from {PROVIDER_TOTAL} providers. Choose a model by name, or let Auto route the task. Keep the SDK you already use.</ApiBody>
          <CtaRow style={{ marginTop: 28 }}><PrimaryCta restrained label="Get an API key" href="/signup" full={isXS} /><GhostCta label="Read the docs" href="/docs/api" /></CtaRow>
          <Text style={{ color: c.muted, fontSize: 13, lineHeight: 21, marginTop: 16 }}>Requires Plus or Plus Premium. Usage is billed in credits.</Text>
        </View>
        <View style={{ flex: isCompact ? undefined : 1.12, minWidth: 0 }}>
          <CodePanel tabs={QUICKSTART.slice(0, 3)} wrap size={12} style={{ borderRadius: 8, boxShadow: 'none' }} />
          <Text style={{ color: c.muted, fontFamily: MONO, fontSize: 12, lineHeight: 20, marginTop: 16 }}>{BASE_URL}</Text>
        </View>
      </ApiSplit>
    </Section>
  );
}
export default React.memo(ApiHero);
